import { BookClosed } from '@primer-io/goat-icons'
import * as ArticleComponents from 'components/ArticleComponents'
import Grid from 'ds/Grid'
import { OverviewSection, GuideLink } from 'components/OverviewComponents'
import React from 'react'

const guideLinksData = [
	{
		title: 'Monitoring for processor outages',
		description:
			'Previously, only engineering teams monitored payment performance and outages. With Primer, this task can now be managed by the payments team or product manager, offering a more efficient process and faster response.',
		link: './use-cases/monitoring-for-processor-outages',
		icon: BookClosed,
	},
	{
		title: 'Optimizing 3D Secure conversion',
		description:
			'Optimizing 3D Secure conversion is vital for improving payment success rates. Although 3D Secure is mandatory in certain areas and optional in others, you can enhance both payment authorization and 3D Secure conversion rates.',
		link: './use-cases/optimizing-3d-secure-conversion',
		icon: BookClosed,
	},
	{
		title: 'Monitor fallback usage',
		description:
			'Primer provides smooth payment processing, auto-retrying with a fallback processor for declined or failed payments. However, merchants should be aware when fallbacks are triggered, especially if they incur charges for initial failed attempts. Monitors let you track fallback usage, quickly spotting issues or setup errors, even if the payment is successful.',
		link: './use-cases/monitor-fallback-usage',
		icon: BookClosed,
	},
	{
		title: 'Analyze A/B test results with Split utility',
		description:
			"Primer's Split utility lets merchants run A/B tests in Workflows by randomly distributing traffic using set percentages. Analyze test outcomes and fine-tune payments using Primer's Observability Dashboards.",
		link: './use-cases/analyze-ab-test-results-with-split-utility',
		icon: BookClosed,
	},
	{
		title: 'Using dashboards to optimize payment orchestration',
		description:
			'Dashboards primarily help optimize your payments stack. Their standardized data is essential for making informed decisions and enhancing payment processes.',
		link: './use-cases/using-dashboards-to-optimize-payment-orchestration',
		icon: BookClosed,
	},
]
export default function UseCases({ fullDescription = false }) {
	return (
		<Grid cols={{ md: 2, lg: 2, xl: 2 }} gap={24} style={{ marginTop: 24 }}>
			{guideLinksData.map((guideLink, index) => (
				<GuideLink
					key={index}
					title={guideLink.title}
					description={fullDescription ? guideLink.description : guideLink.description.slice(0, 200) + '...'}
					link={guideLink.link}
					icon={guideLink.icon}
				/>
			))}
		</Grid>
	)
}
